import { cn, Icon, type TableColumn, TableSort } from "@kyan/ui";

import { ClickableInstrument } from "#/components/ClickableInstrument/ClickableInstrument";
import { type Position } from "#/types/positions";
import { isMaturity, parseMaturity } from "#/utils/maturity";

import {
  getCommonColumns,
  type PositionColumnsProps,
} from "../../Positions.constants";
import { totalRowInstrument } from "../AllPositions/AllPositions.constants";
import { ClosePosition } from "../ClosePosition/ClosePosition";

export const defaultSort: TableSort<Position> = {
  key: "instrument",
  order: "asc",
};

export const getOuterColumns = ({
  excludeColumnIds = [],
  openSharePnlCardsModal,
}: PositionColumnsProps): TableColumn<Position>[] => [
  {
    id: "instrument",
    header: "Instrument",
    minWidth: "240px",
    cellClassName: "pl-10",
    columnClassName: "pl-10",
    sort: true,
    cell: (row, { isRowOpen }) => (
      <div className="flex min-w-24 items-center justify-between gap-4">
        <span className="group-last:text-textSecondary">
          {isMaturity(row.instrument)
            ? `${parseMaturity(row.instrument)} (${row.subPositions?.length})`
            : row.instrument}
        </span>

        {row.instrument !== totalRowInstrument && (
          <Icon
            name="caret-up"
            className={cn(
              "text-xxs rotate-90 transition-transform group-last:hidden",
              {
                "rotate-180": isRowOpen,
              },
            )}
          />
        )}
      </div>
    ),
  },
  ...getCommonColumns({ excludeColumnIds, openSharePnlCardsModal }).map(
    (column) =>
      [
        "pnl",
        "delta",
        "gamma",
        "vega",
        "theta",
        "rho",
        "accruedFunding",
      ].includes(column.id)
        ? column
        : { ...column, cell: () => "-" },
  ),
  {
    id: "close",
    header: "Close",
    minWidth: "75px",
    cell: () => null,
  },
];

export const getInnerColumns = ({
  excludeColumnIds = [],
  openSharePnlCardsModal,
}: PositionColumnsProps): TableColumn<Position>[] => [
  {
    id: "instrument",
    header: "Instrument",
    minWidth: "240px",
    cellClassName: "sm:pl-15",
    columnClassName: "sm:pl-15",
    cell: (row) => <ClickableInstrument instrument={row.instrument} />,
  },
  ...getCommonColumns({ excludeColumnIds, openSharePnlCardsModal }),
  {
    id: "close",
    header: "Close",
    minWidth: "75px",
    cell: (position) => <ClosePosition position={position} />,
  },
];
